<template>
  <div id="app" @click="hideLogs" @keydown.esc="closeAll">
    <transition name="fade" mode="out-in">
      <router-view :class="{'show-small-sidebar': !showFull}"/>
    </transition>
    <sidebar-top v-if="showSidebar && loggedIn"></sidebar-top>
    <sidebar-left v-if="showSidebar && loggedIn"></sidebar-left>
    <all-popups @click="closeAll"></all-popups>
    <notifications-list v-if="newMessages.length > 0 && newMessageFlag"
                        :allNotify="newMessages"
                        @readMessage="readMessage($event)"
                        :appFlag="true"
                        class="notify-alert"
                        :class="{ 'notify1': newMessages.length === 1, 'notify2': newMessages.length === 2, 'notify3': newMessages.length > 2 }"
    />
  </div>
</template>

<script>
  import './styles/utils/_reset.scss'
  import './styles/utils/_fonts.scss'
  import allPopups from './components/Popups/popups'
  import {popups} from "./mixins/popups";
  import {sidebar} from "./mixins/utils/sidebar";
  import {mapState,mapGetters,mapMutations, mapActions} from 'vuex'
  import {tokenAndRoute} from "./mixins/utils/tokenAndRoute";
  import notificationsList from './components/Sidebar/notificationList'

  export default  {
    name: 'app',
    components: {
      allPopups,
      notificationsList
    },
    mixins: [popups, sidebar, tokenAndRoute],
    data() {
      return {
        socket: '',
        newMessageFlag: false,
        newMessages: []
      }
    },
    computed: {
      ...mapGetters({
        userData: 'auth/userData',
      }),
      ...mapState({
        showLogs: state => state.sidebar.showLogs,
        token: state => state.auth.token,
        showFull: state => state.sidebar.showFull,
        hideSidebar: state => state.hideSidebar
      }),
    },
    watch: {
      token(val) {
        if (val) {
          this.openWebSocket();
        }
      }
    },
    methods: {
      ...mapMutations({
        setShowLogs: 'sidebar/SET_SHOW_LOGS'
      }),
      ...mapActions({
        loggedIn: 'auth/loggedIn',
        loadUser: 'auth/loadUser',
        loadAssignedRoles: 'roles/getAssignedRoles',
        logout: 'auth/logout',
        getProjects: 'projects/getProjects',
        getAllNotify: 'roles/getAllNotify',
      }),
      readMessage(id) {
        this.newMessages.forEach((item, index) => {
          if (item.id === id) {
            this.newMessages.splice(index, 1);
          }
        })
      },
      hideNotifyAlert() {
        setTimeout(() => {
          this.newMessageFlag = false
        }, 10000)
      },
      openWebSocket() {
        if (localStorage.getItem('token')) {
          let socket = new WebSocket(process.env.VUE_APP_SOCKET);

          socket.onopen = function(e) {
            socket.send(`accessToken:${localStorage.getItem('token')}`);
          };

          socket.onmessage = (event) => {
            if (!event.data.includes('System message')) {
              this.getAllNotify()
              this.newMessages.push(JSON.parse(event.data));
              this.newMessageFlag = true;
              this.hideNotifyAlert();
            }
          };

          socket.onclose = function(event) {
            if (event.wasClean) {
            } else {
              // например, сервер убил процесс или сеть недоступна
              // обычно в этом случае event.code 1006
              console.log('[close] Соединение прервано');
            }
          };

          socket.onerror = function(error) {
            console.log('ошибка', error);
          };
        }
      },
      hideLogs() {

        // if(this.showLogs) {
        //   this.setShowLogs(false)
        // }
      },
      clearStrage() {
        localStorage.removeItem('token')
      },
      clearStorage() {
        const time = localStorage.getItem('clear-time');
        const thisTime = +new Date();
        const limit = eval(process.env.VUE_APP_CLEAR_TIME);
        if (time != null) {
          if (thisTime - +time > +limit) {
            //сохраняем токен
           // let token = localStorage.getItem('token');
            //чистим хранлище
            this.clearStrage();
            //relogin
           // localStorage.setItem('token', token);
            this.logout();
            localStorage.setItem('clear-time', thisTime)
            //this.$store.dispatch('auth/relogin');
          }
        } else {
          localStorage.setItem('clear-time', thisTime);
        }
      },
      switchLang() {
        let lang = localStorage.getItem('lang');
        if (lang && lang != null) {
          this.$i18n.locale = lang
        } else {
          lang =  navigator.language || navigator.userLanguage;
          switch (lang) {
            case ('ru-RU'): this.$i18n.locale = 'ru';
              break;
            case ('en-EN'): this.$i18n.locale = 'en';
              break;
          }
        }
      }
    },
    async created() {
      this.switchLang();
      this.clearStorage();
      // if (!!token && token != null && token != 'null' && !this.userData) {
      //   await this.loadUser();
      //   await this.loadAssignedRoles(this.token);
      // };
      if (this.token) {
        this.openWebSocket();
        await this.getProjects()
      }
    },
  }
</script>

<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #00527F;
  min-height: 100vh;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #00527F;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.notify-alert {
  position: fixed;
  right: 30px;
  bottom: 50px;
  max-height: 400px;
}

.notify1 {
  height: 130px;
}

.notify2 {
  height: 260px;
}

.notify3 {
  height: 100%;
}
</style>
